<template>
    <td-dialog
        :title="$t(title)"
        :before-close="dialogLeaveBillClose"
        :visible.sync="dialogLeaveBillVisible"
        width="1400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        append-to-body
        :lockScroll="false"
    >
        <el-container>
            <el-form ref="leavelBill" class="previewFormWith">
                <td-preview
                    ref="tdPreview"
                    :processDefintionId="templateKey"
                    :taskLinkId="taskKey"
                    :processNumber="processId"
                    :taskId="taskId"
                    :parentFunc="dialogLeaveBillCloseOnly"
                    :groupElement="groupElement"
                    :failFunc="submitFail"
                    :version="version"
                >
                    <td-workflowhistory slot="table" ref="tdHistory" labelWidth="100px" :processId="processId"></td-workflowhistory>
                </td-preview>
            </el-form>
        </el-container>
        <span slot="footer">
            <div>
                <td-workFlowButton
                    v-if="btnShow"
                    :sIng="sIng"
                    :proDefId="proDefId"
                    style="justify-content: center !important;"
                    ref="workFlowButton"
                    :dynamicBtn="dynamicBtn"
                    :loading="loading"
                    :cancel="dialogLeaveBillClose"
                    :defaultBtnHidden="false"
                >
                    <td-button type="button" v-if="hasReadShow" @click="hasRead">{{ $t('pgCommon.HAS_READ') }}</td-button>
                    <td-button type="button" v-if="!btnShow" @click="dialogLeaveBillClose">{{ $t('pgCommon.CANCEL') }}</td-button>
                    <td-button type="danger" v-if="deleteShow" @click="deleteProcess">{{ $t('pgCommon.DELETE') }}</td-button>
                </td-workFlowButton>
            </div>
            <!-- <td-workFlowButton :sIng="sIng" ref="workFlowButton" :dynamicBtn="dynamicBtn" :cancel="dialogLeaveBillClose"></td-workFlowButton> -->
            <!-- <td-button type="button" v-show="submitShow" :loading="loading" @click="btnSubmit()">{{ $t('pgCommon.SUBMIT') }}</td-button> -->
            <!-- <td-button type="button" :disabled="toOtherShow" :loading="loading" @click="toOtherPer">{{ $t('递转') }}</td-button> -->
            <!-- <td-button type="button" v-show="rejectShow" :loading="loading" @click="reject()">{{ $t('pgCommon.REMOVE') }}</td-button> -->
            <!-- <td-button type="button" v-show="returnShow" :loading="loading" @click="btnReturn()">{{ $t('pgCommon.RETURN') }}</td-button> -->
        </span>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
export default {
    props: ['title', 'dialogLeaveBillVisible', 'editItem', 'sIdDisabled', 'btnShow', 'hasReadShow', 'groupElement', 'tdDynamicObjs'],
    created() {
        this.sIng = this.editItem.templateKey + ':' + this.editItem.taskKey;
        this.proDefId = this.editItem.proDefId;
        // this.$refs.tdPreview.$refs.tdDynamic.$refs.dynamicForm.disabled = true;
    },
    // 接收自定义样式和属性
    provide() {
        return {
            tdDynamicObjList: this.tdDynamicObjList
        };
    },
    mounted() {},
    // 定义变量
    data() {
        return {
            version:this.editItem.version,
            tdDynamicObjList: this.tdDynamicObjs,
            deleteShow: false,
            templateKey: this.editItem.templateKey,
            taskKey: this.editItem.taskKey,
            processId: this.editItem.processId,
            taskId: this.editItem.taskId,
            sIng: '',
            dynamicFormInfo: '',
            submitShow: true,
            toOtherShow: false,
            rejectShow: false,
            returnShow: false,
            operEdit: false,
            userIdEdit: false,
            isEdit: true,
            commentEdit: false,
            currPerson: sessionStorage.getItem('userId'),
            currPerName: sessionStorage.getItem('username'),
            loading: false, // 按钮是否为加载状态
            // 请假类型
            leaveBillTypeList: [],
            // 人员列表
            userIdList: [],
            group: '',
            permissionsView: ['workflow:view'],
            permissionsEdit: ['workflow:edit'],
            permissionsAdd: ['workflow:add'],
            tableData: [],
            rowKey: 'taskId',
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            columns: [
                {
                    prop: 'taskKey',
                    align: 'center',
                    label: this.$t('pgCommon.TASK_KEY')
                },
                {
                    prop: 'taskName',
                    align: 'center',
                    label: this.$t('pgCommon.TASK_NAME')
                },
                {
                    prop: 'assignee',
                    align: 'center',
                    label: this.$t('pgCommon.DISPOSE_PERSON')
                },
                {
                    prop: 'comment',
                    label: this.$t('pgCommon.COMMENT'),
                    align: 'center'
                },
                {
                    prop: 'completeTime',
                    label: this.$t('pgCommon.COMPLETED_TIME'),
                    align: 'center'
                }
            ]
        };
    },
    // 定义并实现方法体
    methods: {
        // 删除表单关联的流程
        deleteProcess() {
            let param = {
                proInsId: this.processId
            };
            Api.deleteProIns(param, response => {
                this.operEdit = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                this.$emit('dialogLeaveBillCloseOnly');
            });
        },
        // 提交流程表单
        dynamicBtn(sSeriesButtonList, btnName, btnId) {
            this.loading = true;
            this.$refs.tdPreview.submitForm(sSeriesButtonList, {}, btnName + this.$t('pgCommon.SUCCESS'), this.callback, btnId);
        },
        //回调提交表单方法，用于关闭loading
        callback(valid) {
            this.loading = false;
        },

        // 提交失败方法
        submitFail() {
            this.loading = false;
        },
        // 已阅
        hasRead() {
            this.$refs.tdPreview.submitForm([], {}, this.$t('pgCommon.HAVE_BEEN_READING'));
        },
        // 初始化按钮列表
        initBtnList() {},
        // 流程提交方法(默认)
        btnSubmit() {},
        // 撤回按钮(默认)
        reject() {},
        // 转办按钮(默认)
        toOtherPer() {},
        // 委派按钮(默认)
        orderPerson() {},
        btnCancel() {
            this.$emit('dialogLeaveBillClose');
        },
        // 关闭窗口之前需要调用的方法
        dialogLeaveBillClose() {
            this.loading = false;
            this.$emit('dialogLeaveBillClose');
            this.dialogLeaveBillVisible = false;
            // this.$refs.tdPreview.$refs.tdDynamic.$refs.dynamicForm.disabled = true;
        },
        // eslint-disable-next-line no-unused-vars
        dialogLeaveBillCloseOnly(response) {
            this.$emit('dialogLeaveBillCloseOnly');
        }
    }
};
</script>
<style scoped>
.previewFormWith {
    width: 100%;
}
</style>
